import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Breadcrumbs — compact top-of-page nav for drill flows.
 * @param items - array of { label: string, to?: string } (last item is "current", no link)
 */
export const Breadcrumbs = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm text-slate-500 mb-3" data-testid="breadcrumbs">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <React.Fragment key={`${item.label}-${i}`}>
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="hover:text-blue-700 transition-colors px-1 py-0.5 rounded"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-slate-900 font-medium px-1 py-0.5" : "px-1 py-0.5"}>{item.label}</span>
            )}
            {!isLast ? <ChevronRight className="h-3.5 w-3.5 text-slate-400 shrink-0" /> : null}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
